import React from 'react';
import { useFeedbackAnalytics } from './hooks/useFeedbackAnalytics';
import { FeedbackMetricsCard } from './components/FeedbackMetricsCard';
import { FeedbackByStepCard } from './components/FeedbackByStepCard';
import { RecentFeedbackTable } from './components/RecentFeedbackTable';
import { Button, Alert } from '@/components/ui';

// Feedback Icon
const FeedbackIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className || 'w-6 h-6'}
  >
    <path
      fillRule="evenodd"
      d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const FeedbackSection: React.FC = () => {
  const {
    metrics,
    feedbackList,
    loading,
    error,
    refreshMetrics,
    refreshFeedbackList,
  } = useFeedbackAnalytics();

  const handleRefreshAll = async () => {
    await Promise.all([refreshMetrics(), refreshFeedbackList()]);
  };

  const handleFilterChange = (options: { step?: string; rating?: string }) => {
    refreshFeedbackList(options);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <FeedbackIcon className="w-6 h-6 mr-3 text-primary-600" />
          <h2 className="text-xl font-semibold text-secondary-900">
            User Feedback
          </h2>
        </div>
        <Button variant="outline" onClick={handleRefreshAll} loading={loading}>
          Refresh All
        </Button>
      </div>

      {error && <Alert variant="error">{error}</Alert>}

      <FeedbackMetricsCard metrics={metrics} loading={loading} />
      <FeedbackByStepCard metrics={metrics} loading={loading} />
      <RecentFeedbackTable
        feedbackList={feedbackList}
        loading={loading}
        onFilterChange={handleFilterChange}
      />
    </div>
  );
};

export default FeedbackSection;
